import { Provider } from '@angular/core';

import { SignedTimetablesRepositoryImpl } from '@app/data/repositories/mot/signed-timetables/signed-timetables.repository';
import { SIGNED_TIMETABLES_REPOSITORY } from '@app/domain/repositories/mot/signed-timetables.repository.contract';

export const signedTimetablesRepositoryProvider: Provider = {
  provide: SIGNED_TIMETABLES_REPOSITORY,
  useClass: SignedTimetablesRepositoryImpl
};
